<template>
	<div>
		<Header :title="strings.community.title">{{
			strings.community.header
		}}</Header>

		<QrFab />
	</div>
</template>

<script>
import strings from "@/utils/strings";

import Header from "../shared/Header";
import QrFab from "../shared/QrFab";

export default {
	components: { Header, QrFab },

	data: () => ({
		strings,
	}),
};
</script>
